import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import HomeSideTitle from '../../../homeTitle/HomeSideTitle'
import { Rating } from 'react-simple-star-rating'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { fetchNewComment } from '../../../../redux/action/review/company-review'
import SimpleReactValidator from 'simple-react-validator'
import { toast } from 'react-toastify'
import { fetchCompanyReview } from '../../../../redux/action/company/company-review'
import MainLoading from '../../../../utils/MainLoading'
import moment from "moment-jalaali";
import { useTranslation } from 'react-i18next'

const CompanyComment = ({data}) => {
    const [forceUpdate, setForceUpdate] = useState(0)
    const [comment, setComment] = useState({
        name: '',
        comment: '',
        rate: '',
        user_id: ''
    })
    const lang = localStorage.getItem('lang')
    const {t} = useTranslation();
    const dispatch = useDispatch()
    const company_review = useSelector(state => state.company_review)

    const changeHandler = event => {
        setComment({ ...comment, [event.target.name]: event.target.value })
    }

    const handleRating = (rate) => {
        setComment({...comment, rate: rate/20})
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    useEffect(() => {
        dispatch(fetchCompanyReview(data.profile && data.profile.id))
    }, [data])

    const handleSendComment = (e) => {
        e.preventDefault()
        if (validator.current.allValid()) {
            let commentInfo = {
                name: comment.name,
                comment: comment.comment,
                rate: comment.rate,
                user_id: data.profile.id
            }
            dispatch(fetchNewComment(commentInfo))
            setComment({
                name: '',
                comment: '',
                rate: '',
            })
            validator.current.hideMessages()
            window.scrollTo(0, 0)
        } else {
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})	
        }
    }

    return (
        <div className='company_comments'>
            <div className='comments'>
                <HomeSideTitle>{t("dashboard_nav_company_comments")}</HomeSideTitle>
                {company_review.loading ?
                    <MainLoading />
                :
                company_review.company_review &&
                company_review.company_review.length ?
                    company_review.company_review.map(review => (
                        <div className='comment' key={review.id}>
                            <div className='comment_header'>
                                <span className='comment_header_name'>{review.name}</span>
                                <span className='comment_header_date'>
                                    {lang === 'en' ?
                                        review.created_at && review.created_at.substr(0, 10)
                                    :
                                        moment(review.created_at && review.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')} - {review.created_at.substr(11, 5)
                                    }
                                </span>
                            </div>
                            <p>{review.comment}</p>
                        </div>
                    ))
                :
                    <h6 className='text-center my-3'> {t("No comment has been registered for this booth")} </h6>
                }
            </div>
            <div className='new_comment'>
                <HomeSideTitle>{t("new comment")}</HomeSideTitle>
                <Form className='col-md-6' onSubmit={handleSendComment}>
                    <Form.Group className="mb-3" controlId="name">
                        <Form.Label>{t("your name")} : </Form.Label>
                        <Form.Control type="text" name="name" value={comment.name} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('name', comment.name, 'required')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="comment">
                        <Form.Label>{t("message")} : </Form.Label>
                        <Form.Control as="textarea" rows={3} name="comment" value={comment.comment} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('comment', comment.comment, 'required')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="rate">
                        <Form.Label>{t("Your rating to this booth")} : </Form.Label>
                        <Rating initialValue={0} size='22' fillColor='#ffe301' className='mx-2' name="rate" value={comment.rate} onClick={handleRating} />
                    </Form.Group>
                    <Button className='btn-success px-5' type="submit">
                        {t("send")}
                    </Button>
                </Form>
            </div>
        </div>
    )
}

export default CompanyComment
